import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';

/**
 * Component to display a Council Member's specific allocations
 * and their overall COI completion of recommended to council nominations.
 */
const CouncilMemberCOIDeclarations = ({
  allocatedCount,
  recommendedCount,
  nominationsWithCOICount,
}) => (
  <Card className="mb-4">
    <Card.Header className="py-3">
      <div className="d-flex align-items-center justify-content-between w-100">
        <div className="d-flex align-items-center">
          <i className="fas fa-info-circle me-2 text-primary fs-5" />
          <span className="text-muted">
            Please complete a conflict of interest (COI) declaration for each
            nomination recommended to council.
          </span>
        </div>

        <div className="d-flex align-items-center gap-4 text-nowrap">
          <div className="text-center">
            <div className="fs-4 fw-bold text-dark">
              {nominationsWithCOICount}/{recommendedCount}
            </div>
            <small className="text-muted d-block">COI Completion</small>
          </div>
          <div className="text-center">
            <div className="fs-4 fw-bold text-dark">{allocatedCount}</div>
            <small className="text-muted d-block">My Allocations</small>
          </div>
        </div>
      </div>
    </Card.Header>
  </Card>
);

CouncilMemberCOIDeclarations.propTypes = {
  allocatedCount: PropTypes.number,
  recommendedCount: PropTypes.number,
  nominationsWithCOICount: PropTypes.number,
};

CouncilMemberCOIDeclarations.defaultProps = {
  allocatedCount: 0,
  recommendedCount: 0,
  nominationsWithCOICount: 0,
};

export default CouncilMemberCOIDeclarations;
